import { CommonModule } from '@angular/common'
import { NgModule } from '@angular/core'
import { RouterModule } from '@angular/router'
import { SeFeIconModule, seFeIconShareAndroidFill } from 'se-fe-icon'
import { SeFeToastModule } from 'se-fe-toast'
import { SeFeTranslationsLoader, SeFeTranslationsModule } from 'se-fe-translations'
import { RegistrationCardTranslationsService } from './registration-card-translations.service'
import { RegistrationCardComponent } from './registration-card/registration-card.component'

@NgModule({
  imports: [
    CommonModule,
    RouterModule,
    SeFeIconModule.include([seFeIconShareAndroidFill]),
    SeFeToastModule,
    SeFeTranslationsModule.forChild('se-registration/ui-registration-card/assets')
  ],
  declarations: [
    RegistrationCardComponent
  ],
  exports: [
    RegistrationCardComponent
  ],
  providers: [
    RegistrationCardTranslationsService
  ],
})
export class SeRegistrationUiRegistrationCardModule {
  constructor(public translationsLoader: SeFeTranslationsLoader) {}
}
